<script lang="ts">
  import { onMount, onDestroy } from 'svelte';
  import { csv } from 'd3-fetch';
  import { scaleLinear } from 'd3-scale';
  import Axis from './Basics/AxisBottomV5.svelte';
  import { AccurateBeeswarm } from './AccurateBeeswarm';
  import Circle from './Basics/Circle.svelte';
  import Labels from './Basics/Labels.svelte';

  let { data } = $props();
  let countriesData = data.countriesData;

  let width = $state(0);
  let animate = $state('one-dimensional');
  const height = 350;
  const margin = { top: 40, right: 30, bottom: 20, left: 50 };

  // Toggle between 'beeswarm' and 'one-dimensional'
  const switchCharts = () => {
    animate = animate === 'beeswarm' ? 'one-dimensional' : 'beeswarm';
  };

  // Computed values
  let xDomainData = $derived(countriesData.map((d) => +d.score_Total));

  let xScale = $derived(
    scaleLinear()
      .domain([Math.min(...xDomainData), Math.max(...xDomainData)])
      .range([margin.left, width - margin.right])
  );

  let yScale = $derived(
    scaleLinear()
      .range([margin.top + height, margin.bottom])
      .domain([0, 2])
  );

  let positionedData = $derived(
    new AccurateBeeswarm(
      countriesData,
      (d) => 10,
      (d) => xScale(d.score_Total),
      1,
      0,
      0
    ).calculateYPositions()
  );

  // Animation timing
  let timeoutId = setTimeout(() => {
    animate = 'beeswarm';
  }, 600);

  onDestroy(() => {
    if (timeoutId) clearTimeout(timeoutId);
  });
</script>

<main bind:clientWidth={width} role="presentation">
  {#if width}
    <div class="relative">
      {#if countriesData.length > 0}
        <svg {width} {height} class="chart">
          <g transform="translate(0,0)">
            <Axis {width} {height} {margin} {xScale} ticksNumber={10} />
          </g>
          <Labels
            labelforx={true}
            fillColor={'#fcd34d'}
            {width}
            {height}
            {margin}
            yoffset={-300}
            xoffset={-20}
            label={'Total AI Score →'} />

          <g transform="translate(0,{height / 2})">
            {#each positionedData as country, i}
              <Circle
                {i}
                {yScale}
                stroke={'red'}
                strokeWidth="2"
                opacity="0.3"
                xValue={country.x.toFixed(1)}
                yValue={country.y.toFixed(1)}
                r={10}
                {animate} />
            {/each}
          </g>
        </svg>
      {/if}
    </div>
    <div class="flex justify-center">
      <button class="variant-filled btn mt-4" onclick={switchCharts}>
        {animate === 'beeswarm' ? 'Show 1D' : 'Show Beeswarm'}
      </button>
    </div>
  {/if}
</main>
